/**
 * GA4 — gtag is loaded from index.html (official snippet, before React).
 * This module only handles SPA navigations and shared helpers.
 */

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

export const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID as
  | string
  | undefined;

export function isGaConfigured(): boolean {
  return Boolean(GA_MEASUREMENT_ID && typeof window !== "undefined" && window.gtag);
}

/** SPA route change — sends a page_view via gtag config (Google-recommended). */
export function trackPageView(pagePath: string): void {
  if (!GA_MEASUREMENT_ID || typeof window === "undefined" || !window.gtag) return;

  window.gtag("config", GA_MEASUREMENT_ID, {
    page_path: pagePath,
    page_title: document.title || undefined,
    page_location: `${window.location.origin}${pagePath}`,
  });
}

/** Custom GA4 event (requires gtag from index.html). */
export function trackGaEvent(
  eventName: string,
  params?: Record<string, string | number | boolean | null | undefined>
): void {
  if (!GA_MEASUREMENT_ID || typeof window === "undefined" || !window.gtag) return;
  window.gtag("event", eventName, params);
}
